const emoji = [
  {
    value: "14",
    title: "\u5fae\u7b11",
    ext: "gif"
  },
  {
    value: "101",
    title: "撇嘴",
    ext: "gif"
  },
  {
    value: "102",
    title: "色",
    ext: "gif"
  },
  {
    value: "4",
    title: "\u53d1\u5446",
    ext: "gif"
  },
  {
    value: "104",
    title: "\u58a8\u955c",
    ext: "gif"
  },
  {
    value: "105",
    title: "\u54ed",
    ext: "gif"
  },
  {
    value: "106",
    title: "害羞",
    ext: "gif"
  },
  {
    value: "107",
    title: "闭嘴",
    ext: "gif"
  },
  {
    value: "108",
    title: "睡觉",
    ext: "gif"
  },
  {
    value: "109",
    title: "\u54ed2",
    ext: "gif"
  },
  {
    value: "110",
    title: "尴尬",
    ext: "gif"
  },
  {
    value: "111",
    title: "发怒",
    ext: "gif"
  },
  {
    value: "12",
    title: "\u8c03\u76ae",
    ext: "gif"
  },
  {
    value: "113",
    title: "呲牙",
    ext: "gif"
  },
  {
    value: "114",
    title: "怀疑",
    ext: "gif"
  },
  {
    value: "15",
    title: "\u96be\u8fc7",
    ext: "gif"
  },
  {
    value: "5",
    title: "\u9177",
    ext: "gif"
  },
  {
    value: "117",
    title: "\u6c57",
    ext: "gif"
  },
  {
    value: "118",
    title: "\u6293\u72c2",
    ext: "gif"
  },
  {
    value: "18",
    title: "\u5410",
    ext: "gif"
  },
  {
    value: "120",
    title: "\u7b112",
    ext: "gif"
  },
  {
    value: "121",
    title: "\u5feb\u4e50",
    ext: "gif"
  },
  {
    value: "122",
    title: "\u5947",
    ext: "gif"
  },
  {
    value: "123",
    title: "\u50b2",
    ext: "gif"
  },
  {
    value: "124",
    title: "\u997f",
    ext: "gif"
  },
  {
    value: "125",
    title: "\u7d2f",
    ext: "gif"
  },
  {
    value: "126",
    title: "\u5413",
    ext: "gif"
  },
  {
    value: "127",
    title: "\u6c572",
    ext: "gif"
  },
  {
    value: "128",
    title: "\u9ad8\u5174",
    ext: "gif"
  },
  {
    value: "129",
    title: "\u95f2",
    ext: "gif"
  },
  {
    value: "130",
    title: "\u52aa\u529b",
    ext: "gif"
  },
  {
    value: "131",
    title: "\u9a82",
    ext: "gif"
  },
  {
    value: "30",
    title: "\u7591\u95ee",
    ext: "gif"
  },
  {
    value: "133",
    title: "\u79d8\u5bc6",
    ext: "gif"
  },
  {
    value: "134",
    title: "\u4e71",
    ext: "gif"
  },
  {
    value: "135",
    title: "\u75af",
    ext: "gif"
  },
  {
    value: "136",
    title: "\u54c0",
    ext: "gif"
  },
  {
    value: "137",
    title: "\u9b3c",
    ext: "gif"
  },
  {
    value: "138",
    title: "\u6253\u51fb",
    ext: "gif"
  },
  {
    value: "139",
    title: "bye",
    ext: "gif"
  },
  {
    value: "140",
    title: "\u6c573",
    ext: "gif"
  },
  {
    value: "141",
    title: "\u62a0",
    ext: "gif"
  },
  {
    value: "142",
    title: "\u9f13\u638c",
    ext: "gif"
  },
  {
    value: "143",
    title: "\u7cdf\u7cd5",
    ext: "gif"
  },
  {
    value: "144",
    title: "\u6076\u641e",
    ext: "gif"
  },
  {
    value: "145",
    title: "\u4ec0\u4e48",
    ext: "gif"
  },
  {
    value: "146",
    title: "\u4ec0\u4e482",
    ext: "gif"
  },
  {
    value: "147",
    title: "\u7d2f2",
    ext: "gif"
  },
  {
    value: "148",
    title: "\u770b",
    ext: "gif"
  },
  {
    value: "149",
    title: "\u96be\u8fc72",
    ext: "gif"
  },
  {
    value: "150",
    title: "\u96be\u8fc73",
    ext: "gif"
  },
  {
    value: "151",
    title: "\u574f",
    ext: "gif"
  },
  {
    value: "152",
    title: "\u4eb2",
    ext: "gif"
  },
  {
    value: "153",
    title: "\u54132",
    ext: "gif"
  },
  {
    value: "154",
    title: "\u53ef\u601c",
    ext: "gif"
  },
  {
    value: "45",
    title: "\u5200",
    ext: "gif"
  },
  {
    value: "156",
    title: "\u6c34\u679c",
    ext: "gif"
  },
  {
    value: "157",
    title: "\u9152",
    ext: "gif"
  },
  {
    value: "158",
    title: "\u7bee\u7403",
    ext: "gif"
  },
  {
    value: "159",
    title: "\u4e52\u4e53",
    ext: "gif"
  },
  {
    value: "48",
    title: "\u5496\u5561",
    ext: "gif"
  },
  {
    value: "161",
    title: "\u7f8e\u98df",
    ext: "gif"
  },
  {
    value: "162",
    title: "\u52a8\u7269",
    ext: "gif"
  },
  {
    value: "163",
    title: "\u9c9c\u82b1",
    ext: "gif"
  },
  {
    value: "164",
    title: "\u67af",
    ext: "gif"
  },
  {
    value: "165",
    title: "\u5507",
    ext: "gif"
  },
  {
    value: "166",
    title: "\u7231",
    ext: "gif"
  },
  {
    value: "167",
    title: "\u5206\u624b",
    ext: "gif"
  },
  {
    value: "168",
    title: "\u751f\u65e5",
    ext: "gif"
  },
  {
    value: "169",
    title: "\u7535",
    ext: "gif"
  },
  {
    value: "170",
    title: "\u70b8\u5f39",
    ext: "gif"
  },
  {
    value: "171",
    title: "\u5200\u5b50",
    ext: "gif"
  },
  {
    value: "46",
    title: "\u8db3\u7403",
    ext: "gif"
  },
  {
    value: "173",
    title: "\u74e2\u866b",
    ext: "gif"
  },
  {
    value: "174",
    title: "\u7fd4",
    ext: "gif"
  },
  {
    value: "175",
    title: "\u6708\u4eae",
    ext: "gif"
  },
  {
    value: "176",
    title: "\u592a\u9633",
    ext: "gif"
  },
  {
    value: "177",
    title: "\u793c\u7269",
    ext: "gif"
  },
  {
    value: "178",
    title: "\u62b1\u62b1",
    ext: "gif"
  },
  {
    value: "179",
    title: "\u62c7\u6307",
    ext: "gif"
  },
  {
    value: "180",
    title: "\u8d2c\u4f4e",
    ext: "gif"
  },
  {
    value: "181",
    title: "\u63e1\u624b",
    ext: "gif"
  },
  {
    value: "182",
    title: "\u526a\u5200\u624b",
    ext: "gif"
  },
  {
    value: "183",
    title: "\u62b1\u62f3",
    ext: "gif"
  },
  {
    value: "184",
    title: "\u52fe\u5f15",
    ext: "gif"
  },
  {
    value: "185",
    title: "\u62f3\u5934",
    ext: "gif"
  },
  {
    value: "186",
    title: "\u5c0f\u62c7\u6307",
    ext: "gif"
  },
  {
    value: "187",
    title: "\u62c7\u6307\u516b",
    ext: "gif"
  },
  {
    value: "188",
    title: "\u98df\u6307",
    ext: "gif"
  },
  {
    value: "189",
    title: "ok",
    ext: "gif"
  },
  {
    value: "190",
    title: "\u60c5\u4fa3",
    ext: "gif"
  },
  {
    value: "52",
    title: "\u7231\u5fc3",
    ext: "gif"
  },
  {
    value: "192",
    title: "\u8e66\u54d2",
    ext: "gif"
  },
  {
    value: "193",
    title: "\u98a4\u6296",
    ext: "gif"
  },
  {
    value: "194",
    title: "\u6004\u6c14",
    ext: "gif"
  },
  {
    value: "195",
    title: "\u8df3\u821e",
    ext: "gif"
  },
  {
    value: "196",
    title: "\u53d1\u54462",
    ext: "gif"
  },
  {
    value: "197",
    title: "\u80cc\u7740",
    ext: "gif"
  },
  {
    value: "198",
    title: "\u4f38\u624b",
    ext: "gif"
  },
  {
    value: "199",
    title: "\u800d\u5e05",
    ext: "gif"
  },
  {
    value: "201",
    title: "\u751f\u75c5",
    ext: "png"
  },
  {
    value: "202",
    title: "\u54ed\u6ce3",
    ext: "png"
  },
  {
    value: "203",
    title: "\u5410\u820c",
    ext: "png"
  },
  {
    value: "204",
    title: "\u8ff7\u7cca",
    ext: "png"
  },
  {
    value: "205",
    title: "\u77aa\u773c",
    ext: "png"
  },
  {
    value: "206",
    title: "\u6050\u6016",
    ext: "png"
  },
  {
    value: "207",
    title: "\u5fe7\u6101",
    ext: "png"
  },
  {
    value: "208",
    title: "\u7728\u7709",
    ext: "png"
  },
  {
    value: "209",
    title: "\u95ed\u773c",
    ext: "png"
  },
  {
    value: "210",
    title: "\u9119\u89c6",
    ext: "png"
  },
  {
    value: "211",
    title: "\u9634\u6697",
    ext: "png"
  },
  {
    value: "212",
    title: "\u5c0f\u9b3c",
    ext: "png"
  },
  {
    value: "213",
    title: "\u793c\u72692",
    ext: "png"
  },
  {
    value: "214",
    title: "\u62dc\u4f5b",
    ext: "png"
  },
  {
    value: "215",
    title: "\u529b\u91cf",
    ext: "png"
  },
  {
    value: "216",
    title: "\u91d1\u94b1",
    ext: "png"
  },
  {
    value: "217",
    title: "\u86cb\u7cd5",
    ext: "png"
  },
  {
    value: "218",
    title: "\u5f69\u5e26",
    ext: "png"
  },
  {
    value: "219",
    title: "\u793c\u72693",
    ext: "png"
  },
  {
    value: "0",
    title: "\u6376\u5730",
    ext: "gif"
  },
  {
    value: "1",
    title: "\u6000\u7591",
    ext: "gif"
  },
  {
    value: "2",
    title: "\u6487\u5634",
    ext: "gif"
  },
  {
    value: "3",
    title: "\u8272",
    ext: "gif"
  },
  {
    value: "6",
    title: "\u5bb3\u7f9e",
    ext: "gif"
  },
  {
    value: "7",
    title: "\u95ed\u5634",
    ext: "gif"
  },
  {
    value: "8",
    title: "\u7761\u89c9",
    ext: "gif"
  },
  {
    value: "9",
    title: "\u5927\u54ed",
    ext: "gif"
  },
  {
    value: "10",
    title: "\u5c34\u5c2c",
    ext: "gif"
  },
  {
    value: "11",
    title: "\u53d1\u6012",
    ext: "gif"
  },
  {
    value: "13",
    title: "\u5472\u7259",
    ext: "gif"
  },
  {
    value: "16",
    title: "\u5e05\u5446",
    ext: "gif"
  },
  {
    value: "17",
    title: "\u6298\u78e8",
    ext: "gif"
  },
  {
    value: "19",
    title: "\u5077\u7b11",
    ext: "gif"
  },
  {
    value: "20",
    title: "\u53ef\u7231",
    ext: "gif"
  },
  {
    value: "21",
    title: "\u767d\u773c",
    ext: "gif"
  },
  {
    value: "22",
    title: "\u50b2\u6162",
    ext: "gif"
  },
  {
    value: "23",
    title: "\u5634\u998b",
    ext: "gif"
  },
  {
    value: "24",
    title: "\u56f0",
    ext: "gif"
  },
  {
    value: "25",
    title: "\u6050\u614c",
    ext: "gif"
  },
  {
    value: "26",
    title: "\u6d41\u6c57",
    ext: "gif"
  },
  {
    value: "27",
    title: "\u61a8\u7b11",
    ext: "gif"
  },
  {
    value: "28",
    title: "\u5927\u5175",
    ext: "gif"
  },
  {
    value: "29",
    title: "\u594b\u6597",
    ext: "gif"
  },
  {
    value: "31",
    title: "\u5618",
    ext: "gif"
  },
  {
    value: "32",
    title: "\u6655",
    ext: "gif"
  },
  {
    value: "33",
    title: "\u88ab\u70b8\u4e86",
    ext: "gif"
  },
  {
    value: "34",
    title: "\u9ab7\u9ac5",
    ext: "gif"
  },
  {
    value: "35",
    title: "\u6572\u6253",
    ext: "gif"
  },
  {
    value: "36",
    title: "\u62dc\u62dc",
    ext: "gif"
  },
  {
    value: "37",
    title: "\u53d1\u6296",
    ext: "gif"
  },
  {
    value: "38",
    title: "\u4eb2\u5bc6",
    ext: "gif"
  },
  {
    value: "39",
    title: "\u8df3",
    ext: "gif"
  },
  {
    value: "40",
    title: "\u732a\u5934",
    ext: "gif"
  },
  {
    value: "41",
    title: "\u62e5\u62b1",
    ext: "gif"
  },
  {
    value: "42",
    title: "\u751f\u65e5\u86cb\u7cd5",
    ext: "gif"
  },
  {
    value: "43",
    title: "\u95ea\u7535",
    ext: "gif"
  },
  {
    value: "44",
    title: "\u5730\u96f7",
    ext: "gif"
  },
  {
    value: "47",
    title: "\u4fbf\u4fbf",
    ext: "gif"
  },
  {
    value: "49",
    title: "\u7c73\u996d",
    ext: "gif"
  },
  {
    value: "50",
    title: "\u73ab\u7470",
    ext: "gif"
  },
  {
    value: "51",
    title: "\u67af\u840e\u73ab\u7470",
    ext: "gif"
  },
  {
    value: "53",
    title: "\u5fc3\u788e",
    ext: "gif"
  }
];

export const prefixUrl = "https://a.links123.cn/site/src/feed/imgs/comment/";

export const ext = "gif";

export default emoji;



// WEBPACK FOOTER //
// ./src/emoji.js